var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPushRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM18.75 7V17C18.75 17.4142 18.4142 17.75 18 17.75C17.5858 17.75 17.25 17.4142 17.25 17V7C17.25 6.58579 17.5858 6.25 18 6.25C18.4142 6.25 18.75 6.58579 18.75 7ZM12.184 7.71342L16.024 11.4634C16.1685 11.6045 16.25 11.798 16.25 12C16.25 12.202 16.1685 12.3955 16.024 12.5366L12.184 16.2866C11.8877 16.576 11.4128 16.5704 11.1234 16.274C10.834 15.9777 10.8396 15.5028 11.136 15.2134L13.6585 12.75H6C5.58579 12.75 5.25 12.4142 5.25 12C5.25 11.5858 5.58579 11.25 6 11.25H13.6585L11.136 8.78658C10.8396 8.49718 10.834 8.02234 11.1234 7.726C11.4128 7.42965 11.8877 7.42402 12.184 7.71342Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushRight);
export default __webpack_public_path__ + "static/media/push-right.083c01a9379f060138dac92fa4277c6d.svg";
export { ForwardRef as ReactComponent };